// src/data/coreValuesData.js
/**
 * Central data file for core values used across the website
 * This serves as the single source of truth for our company values
 */

const coreValuesData = [
  {
    id: 'execution',
    title: "Execution",
    description: "Our commitment to execution excellence transforms legal advice into tangible results, as we measure success not by billable hours but by the real-world outcomes for our clients.",
    longDescription: "We define success through real-world client outcomes rather than billable hours, demonstrating our unwavering commitment to execution excellence.",
    icon: "lightning", // Icon reference - will be rendered by the ValueIcon component
    color: "primary"
  },
  {
    id: 'innovation',
    title: "Innovation",
    description: "We drive legal evolution through pioneering arguments that reshape precedent, while embracing cutting-edge technologies that amplify our effectiveness in addressing client challenges.",
    longDescription: "We are harnessing cutting-edge technologies that enhance our ability to solve client challenges effectively.",
    icon: "lightbulb",
    color: "secondary"
  },
  {
    id: 'integrity',
    title: "Integrity",
    description: "We uphold the highest standards of ethics, transparency, and accountability, honoring our commitments to clients and colleagues.",
    longDescription: "We uphold the highest standards of integrity, honoring our commitments to clients and colleagues.",
    icon: "shield",
    color: "accent"
  },
  {
    id: 'trust',
    title: "Trust",
    description: "Trust is the cornerstone of strong legal representation and we honor that with unwavering dedication.",
    longDescription: "Trust is the cornerstone of strong legal representation and we honor that with unwavering dedication.",
    icon: "users",
    color: "primary"
  }
];

export default coreValuesData;